import { INameValue } from "./common.types";

export type ResponseErrors = {
  [key: string]: Array<string>;
};

export interface IResponse<T> {
  data: T;
  errors: Array<string> | [] | ResponseErrors;
  messages: Array<string> | [];
  warnings: Array<string> | [];
}

export interface ISwoolResponseMeta {
  current_page: number;
  from: number;
  last_page: number;
  links: Array<{
    url: string | null;
    label: string;
    active: boolean;
  }>;
  path: string;
  per_page: number;
  to: number;
  total: number;
}
export interface ISwoolResponseLinks {
  first: string;
  last: string;
  prev: string | null;
  next: string | null;
}
export interface ISwoolBaseResponse<T> {
  data: T;
}

export interface ISwoolResponse<T> extends ISwoolBaseResponse<T> {
  links: ISwoolResponseLinks;
  meta: ISwoolResponseMeta;
}

export interface IErrorObject {
  status: number;
  data: {
    errors: ResponseErrors;
    message: string;
  };
}

export interface IPartnersDocDepResponse {
  agencies?: Array<INameValue<number>>;
  document_types?: Array<INameValue<number>>;
  periods?: Array<INameValue<number>>;
  signing_methods?: Array<INameValue<number>>;
  document_statuses?: Array<INameValue<number>>;
  contract_statuses?: Array<INameValue<number>>;
}

export enum EQueryTagTypes {
  PARTNERS = "PARTNERS",
  PARTNER_CONTACTS = "PARTNER_CONTACTS",
  PARTNER_ADDRESSES = "PARTNER_ADDRESSES",
  PARTNER_LICENSES = "PARTNER_LICENSES",
  PARTNER_BANK_ACCOUNTS = "PARTNER_BANK_ACCOUNTS",
  BANKS_LIST = "BANKS_LIST",
  PARTNER_COMPLEX_CONTRACTS = "PARTNER_COMPLEX_CONTRACTS",
  PARTNER_VIRTUAL_CONTRACTS = "PARTNER_VIRTUAL_CONTRACTS",
  PARTNER_VIRTUAL_CONTRACT_BONUSES = "PARTNER_VIRTUAL_CONTRACT_BONUSES",
  SUMMARY_REPORT = "SUMMARY_REPORT",
  DRAFT_REPORT = "DRAFT_REPORT",
  PARTNER_AGREEMENTS = "PARTNER_AGREEMENTS",
  FINAL_REPORT = "FINAL_REPORT",
  DOCUMENT_DEBT = "DOCUMENT_DEBT",
  SERVICE_TOOLS = "SERVICE_TOOLS",
  SERVICE_TOOLS_AUDIT = "SERVICE_TOOLS_AUDIT",
  ST_APP_SETTINGS = "ST_APP_SETTINGS",
  ST_SERVICE_SETTINGS = "ST_SERVICE_SETTINGS",
  ST_ACCOUNT_SETTINGS = "ST_ACCOUNT_SETTINGS",
  PERMISSIONS = "PERMISSIONS",
  TARGETING_SETTINGS = "TARGETING_SETTINGS",
}
